export enum SystemMessageType {
  SETTLEMENT = 'settlement',
  SETTLEMENT_DETAIL = 'settlement-detail',
  IMPORT_CUSTOMERS = 'import-customers',
  IMPORT_INSURANCES = 'import-insurances',
  CHAT = 'chat'
}
